export const MENU_OPEN = '@customization/MENU_OPEN';
export const THEME_LOCALE = '@customization/THEME_LOCALE';
export const THEME_RTL = '@customization/THEME_RTL';
export const THEME_VALUE = '@customization/THEME_VALUE';